import React, { useEffect, useRef, useState } from "react";
import { AiFillPrinter } from "react-icons/ai";
import ReactToPrint from "react-to-print";
import axios from "axios";
import headerLogo from "../../../../asset/johura_logo.png";

import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";

import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import { useGetProductQuery } from "../../../../features/api/productApi";
import { useGetDealersQuery } from "../../../../features/api/dealerApi";
import { useGetInvoicesQuery } from "../../../../features/api/orderinvoiceApi";
import { useLocation } from "react-router-dom";
import { useGetSalesListQuery } from "../../../../features/api/saleslistApi";
import { useGetAllUnitQuery } from "../../../../features/api/unitApi";
import { API_BASE_URL } from "../../../../components/baseUrl";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    paddingBottom: "88pt",
    // padding: 20,
  },
  header: {
    // backgroundColor: "blue",
    color: "white",
    // padding: 10,
    marginBottom: 5,
    textAlign: "center",
    height: "3.8cm",
    // marginBottom: "1cm",
  },
  imgborder: {
    borderBottom: "1px solid green",
    paddingBottom: "5px",
    marginBottom: "3px",
  },
  HedingTextBorder: {
    borderBottom: "1px solid red",
  },

  invTitle: {
    textAlign: "center",
    backgroundColor: "black",
    color: "white",
    padding: "4px 0px",
    fontSize: "12px",
    width: "100px",
    borderRadius: "2px",
    margin: "0 auto",
  },
  invoice: {
    padding: "10px 20px",
    fontSize: "10px",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  invLeft: {
    fontWeight: "bold",
    flexDirection: "column",
    gap: "4px",
  },
  invRight: {},
  invBottom: {
    fontSize: "10px",
    padding: "0 20 10 20",
    flexDirection: "column",
    gap: "8px",
  },
  footer: {
    // backgroundColor: "green",
    color: "white",
    height: "2cm",
    // padding: 10,
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    marginTop: 20,
    textAlign: "center",
    flexDirection: "row",
    justifyContent: "center",
    fontSize: "12",
  },
  footerAddr: {
    height: "",
    color: "black",
    fontSize: "8px",
    margin: "13 auto",
    width: "100%",
    fontWeight: "thin",
  },
  footerBgc: {
    backgroundColor: "#006600",
    height: "0.8cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  table: {
    // width: "100%",
    borderWidth: 1,
    marginHorizontal: 20,
    // marginBottom: 20,
    // padding: 20,
    // paddingBottom:60,
    borderColor: "#D0D0D0",
    fontSize: "10",
    // flexGrow: 1,
    flexFlow: 1,
  },
  tableHeaderBg: {
    backgroundColor: "#aaa",
    // borderStyle: "solid",
    // borderColor: "#000",
    // borderWidth: 1,
  },
  tableRow: {
    flexDirection: "row",
    // borderBottomColor: "#000",
    // borderBottomWidth: 1,
    // alignItems: "center",
    // height: 30,
  },
  tableCell: {
    // flex: 1,
    // justifyContent: "center",
    borderBottomWidth: 1,
    borderRight: 1,
    borderColor: "#D0D0D0",
    // alignItems: "center",
    textAlign: "center",
    padding: 6,
  },
  tableCellTitle: {
    marginBottom: 4,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },
  author: {
    fontSize: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "50px",
    padding: "0 20px",
  },
  authorText: {
    borderTop: "1px solid black",
    paddingTop: "1px",
  },
  pageNumber: {
    position: "absolute",
    bottom: 55,
    right: 20,
    // marginLeft: 0,
    // textAlign:'right',

    fontSize: 10,
  },
});

function Testing() {
  // useRef for report
  const componentRef = useRef();
  const [visible, setVisible] = useState(true);

  const location = useLocation();
  const row = location?.state?.row;
  const dName = location?.state?.dName;
  const orderInvoice = row;
  const invoice_no = orderInvoice?.inv_no;

  const { data: prodct } = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const products = prodct?.products;

  const { data: ordr } = useGetSalesListQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const orders = ordr?.orderss;

  const { data } = useGetInvoicesQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const orders2 = data?.orders_twos;
  const filteredItems = orders2?.filter(
    (item) =>
      item?.dealer === orderInvoice?.dealer &&
      parseInt(item?.inv_no) < invoice_no
  );
  const sumOfTotal = filteredItems?.reduce((sum, item) => sum + item?.total, 0);
  const sumOfPaid = filteredItems?.reduce((sum, item) => sum + item?.paid, 0);

  const { data: dlr } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = dlr?.dealer;

  const { data: unt } = useGetAllUnitQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const units = unt?.units;

  // filter for select invoice
  const filterOrders = orders?.filter((order) => order?.inv_no === invoice_no);

  const filterDealer = dealers?.filter(
    (d) => d?.d_name === orderInvoice?.dealer
  );
  const findDealer = filterDealer?.find((d) => d);

  const [transaction, setTransaction] = useState([]);
  useEffect(() => {
    const fetchTransaction = async () => {
      const response = await axios.get(
        `${API_BASE_URL}/api/TransactionQuery?ledger_id=1&tag_ac_id=${findDealer?.id}`
      );
      setTransaction(response?.data?.transactions);
    };
    fetchTransaction();
  }, [findDealer?.id]);

  let balance = 0;

  transaction?.map((data, index) => {
    const { dabit_amount, credit_amount } = data;
    balance += dabit_amount - credit_amount;
    return balance;
  });

  // function for formated date
  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <div className="w-full max-w-[1280px] mx-auto px-6 md:px-auto h-[90vh] overflow-auto">
      <input
        onClick={() => setVisible(!visible)}
        type="checkbox"
        defaultChecked
        className="cursor-pointer"
      />
      <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <Document>
          <Page size="A4" style={styles.page}>
            {/* Header */}
            <View style={styles.header} fixed>
              {visible && (
                <View>
                  <View style={styles.imgborder}>
                    <Image src={headerLogo} />
                  </View>
                  <Text style={styles.HedingTextBorder}></Text>
                </View>
              )}
            </View>

            {/* Invoice */}
            <View style={styles.invMain}>
              <Text style={styles.invTitle}>INVOICE</Text>
              <View style={styles.invoice}>
                <View style={styles.invLeft}>
                  <Text>To</Text>
                  <Text>Member Admin</Text>
                  <Text>ibn sina trust</Text>
                  <Text>H # 48, R # 9/A, Dhanmondi, Dhaka</Text>
                </View>
                <View style={styles.invRight}>
                  <Text>Bill No: IV-5/23</Text>
                  <Text>Bill Date: 16-10-2023</Text>
                </View>
              </View>
              <View style={styles.invBottom}>
                <Text>
                  Sub: Bill of supply & installation of spare part & servicing
                  the olympus video endoscopy ( Model: GIF-H190, SL No: 2527042)
                  for ibn sina diagnostic center
                </Text>
                <Text>
                  Ref: Our offer no-JES-18-90 Date: 23.07.2019 Challan no -
                  JES-19-67 Date: 23.07.2019
                </Text>
              </View>
            </View>

            {/* Table */}
            <View style={styles.table}>
              {/* Table Header */}
              <View
                style={{ ...styles.tableRow, ...styles.tableHeaderBg }}
                fixed
              >
                <View style={{ ...styles.tableCell, width: "4%" }}>
                  <Text>Sl.</Text>
                </View>
                <View style={{ ...styles.tableCell, width: "12%" }}>
                  <Text>Invoice no.</Text>
                </View>
                <View style={{ ...styles.tableCell, width: "12%" }}>
                  <Text>Invoice date</Text>
                </View>
                <View style={{ ...styles.tableCell, width: "26%" }}>
                  <Text>Client Name</Text>
                </View>
                <View style={{ ...styles.tableCell, width: "18%" }}>
                  <Text>Product</Text>
                </View>
                <View style={{ ...styles.tableCell, width: "8%" }}>
                  <Text>Qty</Text>
                </View>
                <View style={{ ...styles.tableCell, width: "8%" }}>
                  <Text>Rate</Text>
                </View>
                <View
                  style={{ ...styles.tableCell, width: "12%", borderRight: 0 }}
                >
                  <Text>Total Amt</Text>
                </View>
              </View>

              {/* Table Data */}
              {orders?.map((row, index) => {
                const proName = products?.find(
                  (pro) => pro?.id === row?.pro_name
                );
                const exists = orders2?.find(
                  (exist) => exist?.inv_no === row?.inv_no
                );
                const dealerName = dealers?.find(
                  (dlr) => dlr?.id === +exists?.dealer
                );
                return (
                  <View key={index} style={styles.tableRow}>
                    <View style={{ ...styles.tableCell, width: "4%" }}>
                      <Text>{index + 1}</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "12%" }}>
                      <Text>{row.inv_no}</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "12%" }}>
                      <Text>{formatDate(row.inv_date)}</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        width: "26%",
                        textAlign: "left",
                      }}
                    >
                      <Text>{dealerName?.d_name}</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "18%" }}>
                      <Text> {proName?.product_name}</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "8%" }}>
                      <Text> {row?.qty}</Text>
                    </View>
                    <View style={{ ...styles.tableCell, width: "8%" }}>
                      <Text> {row?.sales_rate}</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        width: "12%",
                        borderRight: 0,
                      }}
                    >
                      <Text>{row.total}</Text>
                    </View>
                  </View>
                );
              })}
              <View style={styles.tableRow}>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    width: "12%",
                    borderBottom: 0,
                  }}
                >
                  <Text></Text>
                </View>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    width: "12%",
                    borderBottom: 0,
                  }}
                >
                  <Text></Text>
                </View>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    width: "12%",
                    borderBottom: 0,
                  }}
                >
                  <Text></Text>
                </View>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    width: "12%",
                    borderBottom: 0,
                  }}
                >
                  <Text></Text>
                </View>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    width: "6%",
                    borderBottom: 0,
                  }}
                >
                  <Text></Text>
                </View>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    width: "6%",
                    borderBottom: 0,
                  }}
                >
                  <Text></Text>
                </View>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    width: "20%",
                    borderBottom: 0,
                  }}
                >
                  <Text>Quantity: quantity</Text>
                </View>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    width: "20%",
                    borderBottom: 0,
                  }}
                >
                  <Text>Total: total</Text>
                </View>
              </View>
            </View>
            <View style={styles.author} fixed>
              <Text style={styles.authorText}>Received By:</Text>
              <Text>Prepared By:</Text>
              <Text style={styles.authorText}>Authorised Signature</Text>
            </View>

            {/* Page Number */}
            <View style={styles.pageNumber} fixed>
              <Text
                render={({ pageNumber, totalPages }) =>
                  `page ${pageNumber} of ${totalPages}`
                }
              />
            </View>

            {/* Footer */}
            <View style={styles.footer} fixed>
              {visible && (
                <View style={styles.footerAddr}>
                  <Text>
                    15/A Zigatola, Hafizullah Green Tower, Flat # C1, Dhanmondi,
                    Dhaka - 1209
                  </Text>
                  <Text>
                    Cell: 01711-071102, 01977-071102, 01778-874364, E-mail:
                    jahangirjohura@gmail.com / Web: www.johurabd.com
                  </Text>
                </View>
              )}
              {visible && <Text style={styles.footerBgc}></Text>}
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
}

export default Testing;
